import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/banners';

const unwrap = (response) => response.data?.data ?? response.data;

const bannerService = {
  listBanners: async ({ includeInactive = true } = {}) => {
    const params = {};
    if (includeInactive) {
      params.include_inactive = 'true';
    }
    const response = await apiClient.get(BASE, { params });
    const data = unwrap(response);
    const items = data?.items ?? [];
    return Array.isArray(items) ? items : [];
  },

  createBanner: async (payload) => {
    const response = await apiClient.post(BASE, payload);
    return unwrap(response);
  },

  updateBanner: async (id, payload) => {
    const response = await apiClient.patch(`${BASE}/${id}`, payload);
    return unwrap(response);
  },

  deleteBanner: async (id) => {
    const response = await apiClient.delete(`${BASE}/${id}`);
    return unwrap(response);
  },
};

export default bannerService;
